export default __webpack_public_path__ + "static/media/fibonacci_retracement.c64c1511.svg";